import { useEffect, useCallback, useState } from 'react';
import { getFlags, setFlag } from '@atlassian/jira-common-have-i-seen-it/src/index.tsx';
import type { HaveISeenItFlags } from '@atlassian/jira-common-have-i-seen-it/src/types.tsx';
import { fg } from '@atlassian/jira-feature-gating';

const TTL_SEEN = 1000 * 60 * 60 * 24 * 365; // ~ 365 days

const SEEN_ONBOARDING = 'saved-views-dropdown';

// TODO: SLV-286 - delete this file during spotlight cleanup

export const useSavedViewsSpotlightOnboarding = () => {
	const [isOnboardingVisible, setIsOnboardingVisible] = useState(false);

	useEffect(() => {
		if (__SERVER__ || !fg('saved_list_view_changeboarding')) {
			return;
		}

		getFlags({
			[SEEN_ONBOARDING]: {},
		})
			.then((seenItResponse: HaveISeenItFlags) => {
				const isOnboardingSeen = seenItResponse[SEEN_ONBOARDING]?.status;
				if (isOnboardingSeen !== true) {
					setIsOnboardingVisible(true);
				}
			})
			.catch(() => {
				// Ignore errors
			});
	}, []);

	const markAsSeen = useCallback(() => {
		setIsOnboardingVisible(false);
		setFlag(SEEN_ONBOARDING, TTL_SEEN);
	}, []);

	return [isOnboardingVisible, markAsSeen] as const;
};
